import { Base2Presenter } from "core/presenter";
import { OrderIntegration } from "core/repository";

class CompanyIntegrationsOderIntegrationPresenter extends Base2Presenter {
  initialState() {
    return {
      data: [],
      loading: true,
      editingWebhook: false,
      webhook: { endpoint: "", actions: [] },
      errors: {}
    };
  }

  onStart() {
    this.load();
  }

  async load() {
    this.enqueue({ loading: true });

    const companyUuid = this.routeParams.companyUuid;
    const currentUser = await this.mRuntime.get("currentUser");

    const result = await OrderIntegration.getOrderIntegration(
      companyUuid === "minha-empresa" ? currentUser.company_uuid : companyUuid
    );

    if (result.success) {
      this.enqueue({ data: result.data });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não conseguimos buscar as integrações para esta empresa! Tente novamente em alguns minutos."
      });
    }

    this.enqueue({ loading: false });
  }
}

export default CompanyIntegrationsOderIntegrationPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/order_integrations/presenter.js